import { Component, Inject, Input } from '@angular/core';
import { ApplicationFacade } from '@ridango/components';
import { AppStartupService, DisruptionMessagesSummary, DisruptionMessageType } from '@ridango/core';
import { Temporal } from '@js-temporal/polyfill';
import { DatePipe } from '@angular/common';
import Env from '@ridango/core/env';

@Component({
    selector: 'rwidget-disruption-messages-summary',
    templateUrl: './disruption-messages-summary.component.html',
    styleUrls: ['./disruption-messages-summary.component.scss']
})
export class DisruptionMessagesSummaryComponent {
    @Input() messagesSummary: DisruptionMessagesSummary[];
    @Input() packageVersion: Date;

    private readonly timeZone = this.appStartup.getTimezone();
    private readonly timeZoneOffSet = this.appStartup.getTimezoneOffset;

    public readonly assetsPath$ = this.applicationFacade.assetsPath$;

    constructor(
        @Inject('ENV') public env: Env,
        private applicationFacade: ApplicationFacade,
        private appStartup: AppStartupService,
        private datePipe: DatePipe
    ) {}

    customIconTag(tag: string) {
        return (
            this.env.DISRUPTION_MESSAGES?.CUSTOM_ICONS &&
            this.env.DISRUPTION_MESSAGES?.CUSTOM_ICONS?.includes(tag as DisruptionMessageType)
        );
    }

    get dateTime(): string {
        if (this.env.APP_NAME !== 'vastmanland-app') {
            return this.datePipe.transform(this.packageVersion, this.env.PERIOD_TICKET_DATE_FORMAT);
        }

        const instant = Temporal.Instant.from(this.packageVersion.toString());
        const currentTimeStamp = instant.toZonedDateTimeISO(this.timeZone).epochMilliseconds;

        return this.datePipe.transform(
            currentTimeStamp || this.packageVersion,
            this.env.PERIOD_TICKET_DATE_FORMAT,
            this.timeZoneOffSet
        );
    }

    get filteredMessagesSummary() {
        return this.messagesSummary?.filter((summary) => summary.amount > 0) || [];
    }

    get hasAlerts(): boolean {
        return this.filteredMessagesSummary?.length > 0;
    }
}
